import React from "react";
// import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import ChartistGraph from "react-chartist";
import Chartist from "chartist";

const styles = {};

function HorizontalBarChart(props) {
	const options = {
		seriesBarDistance: 150,
		distributeSeries: true,
		horizontalBars: true,
		high: 25,
		height: 600,
		axisY: {
			offset: 70
		}
	};

	const animation = {
		animation: {
			draw: data => {
				if (data.type === "bar") {
					data.element.attr({
						style: "stroke-width: 27px"
					});
					data.element.animate({
						x2: {
							begin: 1000,
							dur: 1500,
							from: data.x1,
							to: data.x2,
							easing: Chartist.Svg.Easing.easeOutQuint
						}
					});

					// data.group.append(
					// 	new Chartist.Svg(
					// 		"circle",
					// 		{
					// 			cx: data.x2,
					// 			cy: data.y2,
					// 			r: Math.abs(Chartist.getMultiValue(data.value.x))
					// 		},
					// 		"ct-slice-pie"
					// 	)
					// );
				}
			}
		}
	};

	var data = { series: [], labels: [] };
	var list = [];
	props.series.forEach((val, index) => {
		list.push({ label: props.labels[index], value: val });
	});

	list.sort(function(a, b) {
		return a.value < b.value ? -1 : a.value === b.value ? 0 : 1;
	});
	list.forEach(val => {
		data.series.push(val.value);
		data.labels.push(val.label);
	});

	return (
		<ChartistGraph
			className="ct-chart"
			data={data}
			type="Bar"
			options={options}
			listener={animation.animation}
		/>
	);
}

export default withStyles(styles)(HorizontalBarChart);
